import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  ATTACHMENTS_REFRESH: createSagaAction('ATTACHMENTS_REFRESH'),

  ATTACHMENT_CREATE: createSagaAction('ATTACHMENT_CREATE'),
  ATTACHMENT_UPDATE: createSagaAction('ATTACHMENT_UPDATE'),
  ATTACHMENT_DELETE: createSagaAction('ATTACHMENT_DELETE'),

  GET_ATTACHMENTS: createSagaAction('GET_ATTACHMENTS')
}

// Action Creators
export const actions = {
  attachmentsRefresh: ({ jobId }) => ({
    type: constants.ATTACHMENTS_REFRESH.ACTION,
    jobId
  }),

  createAttachment: ({ jobId, content, file, filename, userId }) => ({
    type: constants.ATTACHMENT_CREATE.ACTION,
    jobId,
    content,
    file,
    filename,
    userId
  }),

  updateAttachment: ({ jobId, description, attachmentId, userId }) => ({
    type: constants.ATTACHMENT_UPDATE.ACTION,
    jobId,
    description,
    attachmentId,
    userId
  }),

  deleteAttachment: ({ jobId, attachmentId }) => ({
    type: constants.ATTACHMENT_DELETE.ACTION,
    jobId,
    attachmentId
  }),

  getAttachments: ({ jobId, attachmentId, attachmentType }) => ({
    type: constants.GET_ATTACHMENTS.ACTION,
    jobId,
    attachmentId,
    attachmentType
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.ATTACHMENTS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.ATTACHMENTS_REFRESH.SUCCESS:
      return {
        ...state,
        attachments: action.payload
      }
    case constants.ATTACHMENTS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.ATTACHMENT_CREATE.ACTION:
      return { ...state, error: null, loading: true }
    case constants.ATTACHMENT_CREATE.SUCCESS:
      return {
        uploadFinish: action.payload,
        ...state
      }
    case constants.ATTACHMENT_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.ATTACHMENT_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_ATTACHMENTS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobAttachments: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobAttachmentActions.js